import styled from "styled-components";

import { layout } from "/styles";

export const Availability = styled.span(layout.flexCenterHorizontal, ({ theme }) => ({
  "& > svg": {
    marginRight: theme.spacing.base,
  },
}));
